// eslint-disable-next-line import/prefer-default-export
export enum FileConfig {
  MaxFileSizeInMB = 95,
  MaxRows = 100000,
  MaxColumns = 120,
}
